import { ReactNode } from 'react';
import { Validators } from '../../../../config/constants';
import useToastState from '../../../../context/toast/useToastState';
import { validateErrors } from '../../../../helpers';

type EditPositionWrapperProps<T> = {
    component: React.FC<T>;
    props: Omit<T, 'children'>;
    children(confirm: {
        confirm: () => Promise<void>;
        validate: () => boolean;
        isApproved: boolean;
        approve?: (approveAmount: string) => Promise<void>;
    }): ReactNode;
};

type EditPositionTypeBaseProps = {
    children(confirm: {
        confirm: () => Promise<void>;
        validators: Validators[];
        isApproved?: boolean;
        approve?: (approveAmount: string) => Promise<void>;
    }): ReactNode;
};

const EditPositionWrapper = <T extends EditPositionTypeBaseProps>({
    component: Component,
    children,
    props,
}: EditPositionWrapperProps<T>) => {
    const { setToast } = useToastState();

    return (
        <Component {...(props as T)}>
            {({ confirm, validators, approve, isApproved }) =>
                children({
                    confirm,
                    validate: () =>
                        validateErrors(validators, (message) =>
                            setToast(
                                {
                                    type: 'danger',
                                    message,
                                },
                                message
                            )
                        ),
                    // if isAApproved is not defined, we set it to true by default
                    isApproved: isApproved ?? true,
                    approve,
                })
            }
        </Component>
    );
};

export default EditPositionWrapper;
